module.exports = __webpack_public_path__ + "img/Venus-full.92538359.png";